<template lang="html">
  <b-row>
    <b-col>
      <!-- Non search content. -->
      <div v-if="!isSearchResults">
        <!-- Tabs only available lg and higher.-->
        <div class="d-none d-md-block">
          <b-tabs content-class="mt-3">
            <b-tab
              title="All items"
              :active="!isKnownChordResults"
              @click="gotoPathRoot"
            />
            <b-tab
              title="Only items with chords I know"
              :active="isKnownChordResults"
              @click="gotoPathRootKnownChords"
            >
              <template v-slot:title>
                Only items with chords I know
                <b-badge variant="primary" class="ml-1">
                  {{ $store.getters.knownChordSongCount.toLocaleString() }}
                </b-badge>
              </template>
            </b-tab>
          </b-tabs>

          <b-row v-if="!isSearchResults" class="mt-4">
            <b-col>
              <h5>
                You know
                {{ $store.getters.knownChords.length.toLocaleString() }} chords.
                This allows you to play
                {{ $store.getters.knownChordSongCount.toLocaleString() }}
                songs.
              </h5>

              <p
                v-if="
                  $store.getters.knownChords.length < 7 && !isKnownChordResults
                "
                class="small"
              >
                <span class="mark">
                  If you know a chord, click it and see how many songs you can
                  now play.
                </span>
              </p>
            </b-col>
          </b-row>
        </div>

        <div class="d-md-none">
          <!-- Buttons only available md and smaller.-->
          <div class="mb-4">
            <b-btn
              :variant="!isKnownChordResults ? 'primary' : 'outline-secondary'"
              size="sm"
              class="mr-1 mb-1"
              @click="gotoPathRoot"
            >
              All items
            </b-btn>
            <b-btn
              :variant="isKnownChordResults ? 'primary' : 'outline-secondary'"
              size="sm"
              class="mr-1 mb-1"
              @click="gotoPathRootKnownChords"
            >
              Only items with chords I know
            </b-btn>
          </div>
          <b-row v-if="!isSearchResults">
            <b-col>
              <p>
                You know
                {{ $store.getters.knownChords.length.toLocaleString() }} chords,
                for
                {{ $store.getters.knownChordSongCount.toLocaleString() }}
                songs.
              </p>
              <p
                v-if="
                  $store.getters.knownChords.length < 7 && !isKnownChordResults
                "
                class="small"
              >
                If you know a chord, click it and see how many songs you can now
                play.
              </p>
            </b-col>
          </b-row>
        </div>
      </div>

      <!-- Search content. -->

      <SearchField v-if="isSearchResults" />

      <!-- End top content. -->

      <b-row
        v-show="$store.state.song_query_results.length > 0"
        id="topPagination"
      >
        <b-col class="mt-3  mb-4">
          <b-pagination-nav
            v-model="$store.state.song_query_page"
            :number-of-pages="$store.state.song_query_num_of_pages"
            :link-gen="linkGen"
            :prev-text="prevText"
            :next-text="nextText"
            use-router
            pills
            class="float-left"
          />

          <div class="float-right form-group form-inline">
            <b-form-checkbox
              v-model="hideKnownChordShapes"
              name="flavour-4a"
              inline
              class="ml-2 d-none d-lg-block"
            >
              Hide known chord diagrams
            </b-form-checkbox>
            <b-form-select v-model="sort_order" :options="sort_order_options" />
          </div>
        </b-col>
      </b-row>

      <NonStandardTuningWarning
        v-if="$store.getters.ukeTuning == 'G'"
        class="mb-3"
      />

      <div>
        <ThumbList :class="$store.state.resultsLoading ? 'loading' : null" />
      </div>
      <b-pagination-nav
        v-show="
          !$store.state.resultsLoading &&
            $store.state.song_query_results.length > 0
        "
        v-model="$store.state.song_query_page"
        :number-of-pages="$store.state.song_query_num_of_pages"
        :link-gen="linkGen"
        :prev-text="prevText"
        :next-text="nextText"
        use-router
        pills
        class="mb-5"
        @change="paginationChangedBottom"
      />
    </b-col>
  </b-row>
</template>

<script>
import ThumbList from "@/components/ThumbList";
import SearchField from "@/components/SearchField";
import NonStandardTuningWarning from "@/components/NonStandardTuningWarning";

import clone from "lodash/clone";
export default {
  name: "NavPaginatedSongList",
  components: {
    ThumbList,
    SearchField,
    NonStandardTuningWarning
  },
  data() {
    return {
      sort_order_options: [
        { value: "views-desc", text: "Sort by most views" },
        { value: "views-asc", text: "Sort by least views" },
        { value: "title-asc", text: "Sort by title" },
        { value: "title-desc", text: "Sort by title - reversed" }
      ],
      queryModeTabIndex: 0,
      prevText: "Prev",
      nextText: "Next"
    };
  },

  computed: {
    isKnownChordResults() {
      return this.$route.meta.onlyKnownChords;
    },
    isSearchResults() {
      return "search" in this.$route.query;
    },
    tabIndex: {
      set(value) {
        this.queryModeTabIndex = value;

        var pathRoot = this.$route.name;
        if (this.$route.name.endsWith("-known-chords")) {
          pathRoot = this.$route.name.split("-known-chords")[0];
        }

        if (value == 0) {
          this.$router.push({
            name: pathRoot
          });
        } else {
          this.$router.push({
            name: pathRoot + "-known-chords"
          });
        }
        console.log(this.queryModeTabIndex);
      },
      get() {
        return this.queryModeTabIndex;
      }
    },
    hideKnownChordShapes: {
      set(value) {
        console.log(value);
        this.$store.dispatch("updateChordHiding", value);
      },
      get() {
        return this.$store.state.userPreferences.hideKnownChordShapes;
      }
    },
    sort_order: {
      set(value) {
        this.$store.dispatch("updateSortOrder", value);
      },
      get() {
        return this.$store.state.userPreferences.sortOrder;
      }
    }
  },

  mounted() {},
  methods: {
    gotoPathRoot() {
      console.log("gotoPathRoot");
      if (this.$route.name.endsWith("-known-chords")) {
        var pathRoot = this.$route.name.split("-known-chords")[0];
        this.$router.push({
          name: pathRoot,
          params: {
            tuning: this.$store.getters.ukeTuning
          }
        });
      }
      if (this.$route.name == "front") {
        this.$router.push({
          name: "playalongs",
          params: {
            tuning: this.$store.getters.ukeTuning
          }
        });
      }
    },
    gotoPathRootKnownChords() {
      if (
        this.$route.name.endsWith("-known-chords") ||
        this.$route.name == "front"
      ) {
        return;
      }
      var pathRoot = this.$route.name;
      this.$router.push({
        name: pathRoot + "-known-chords",
        params: {
          tuning: this.$store.getters.ukeTuning
        }
      });
    },
    linkGen(pageNum) {
      var query = clone(this.$route.query);
      query.page = pageNum;
      return {
        name: this.$route.name,
        query: query
      };
    },

    displayChord(chordName) {
      if (!this.hideKnownChordShapes) {
        return true;
      }
      if (this.$store.getters.knownChords.includes(chordName)) {
        return false;
      }
      return true;
    },

    returnFillColor(chordName) {
      if (this.$store.getters.knownChords.includes(chordName)) {
        return "green";
      }
      return "black";
    },
    paginationChangedBottom() {
      var $topPagination = document.getElementById("topPagination");
      console.log($topPagination.offsetTop);
      console.log($topPagination.PageY);
      $topPagination.scrollIntoView();
      //window.scrollTo(0, $topPagination.pageY);
    }
  }
};
</script>

<style lang="scss" scoped>
.loading {
  opacity: 0.2;
}
.loading-alert {
  position: absolute;
  width: 100%;
}
</style>
